<h3 sidenav-title>{{ 'Notifications' }}</h3>

<sidenav-content>
    <app-jumbotron *ngIf="isLoaded" [headerText]="'No notifications to display.'" [showEmptyImg]="false">
    </app-jumbotron>
</sidenav-content>
